import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import camera from "../../assets/svg/camera-add.svg";
import cancel from "../../assets/svg/close-modal.svg";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
const CapturePictureModal = ({ onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "338px",
      /* height:"425px", */
      textAlign: "center",
      overflowY: "auto",
    },
  };




  const activeRef = useRef(true);

  useEffect(() => {
    activeRef.current = true;
    setImage(null);
    getVideo();
    return () => {
      activeRef.current = false;
      stopVideo();
    };
  }, [])

  const videoRef = useRef(null);
  const streamRef = useRef(null);



  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Set canvas size to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame on the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to image URL
    const imageUrl = canvas.toDataURL("image/png");
    setImage(imageUrl);
    stopVideo();
  };





  const getVideo = () => {
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then(stream => {
        if (!activeRef.current) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          const playPromise = videoRef.current.play();
          if (playPromise !== undefined) {
            playPromise.catch(err => {
              console.log("Video play promise caught:", err.message);
            });
          }
        }
      })
      .catch(err => {
        if (activeRef.current) {
          console.error("Error accessing camera:", err);
          setErrorMessage("Error accessing camera. Please ensure permissions are granted.");
        }
      });
  };
  // const stopVideo = () => {
  //   if (streamRef.current) {
  //       streamRef.current.getTracks().forEach(track => track.stop());
  //       streamRef.current = null;
  //       if (videoRef.current) {
  //           videoRef.current.srcObject = null;
  //       }
  //   }
  //   streamRef.current=null;
  // };

  const stopVideo = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };


  const handleOpen = () => {
    setImage(null);
  };

  return (<div style={modalStyle.overlay}>
    <div style={modalStyle.modal}>
      <div className="GTWalsheimTrial">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexDirection: 'column', alignItems: 'start' }}>

            <div
              style={{
                paddingLeft: "4px",
                fontSize: "20px",
                fontWeight: "400",
                color: '#98A1B0'
              }}
            >
              {/*  {ticketDetail.title??''} */}
            </div>
          </div>


          <ModalCloseIcon
            style={{ cursor: "pointer" }}
            onClick={onCancel}
          />
        </div>
        {image == null && (<div>
          <span style={{
            fontWeight: "700",
            fontSize: '16px',
            lineHeight: '21.6px',
            color: '#212129',
            marginBottom: '16px'
          }}>
            Place the picture inside the area
          </span>

          {/* Camera Feed */}
          {image == null && (<video ref={videoRef} autoPlay playsInline style={{
            width: '100%',
            height: '80%',
            borderRadius: "7px",
            objectFit: 'cover',

          }}></video>)}
          <canvas ref={canvasRef} style={{ display: "none" }} />


          <div style={{ width: '100%', display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
            <div onClick={() => { stopVideo(); onCancel() }} style={{ width: '44px', height: '44px', borderRadius: '68px', border: '0.6px solid #D4DDE7', padding: '10px', backgroundColor: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src={cancel} alt="" />
            </div>
            {image == null && (<div onClick={() => { captureImage() }} style={{ width: "50px", height: '50px', borderRadius: '1000px', border: '1px solid #D4DDE7', padding: '2px 3px 2px 3px', backgroundColor: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src={camera} style={{ width: '24px', height: '24px', margin: '0' }} />
            </div>)}
            {/* {image && ( <div onClick={()=>{setImage(null);getVideo();handleOpen();}} style={{width:'44px',height:'44px',borderRadius:'68px',border:'0.6px solid #D4DDE7',padding:'10px',backgroundColor:'#FFFFFF',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <img src={retake} alt="" />
                                </div>)} */}
          </div>
        </div>)}
        {image && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <img src={image} alt="Captured" style={{
              width: '100%',
              height: '80%',
              borderRadius: "7px",
              objectFit: 'cover',
            }} />

            <div style={{ marginTop: '16px', display: 'flex', }}>
              <button onClick={() => { setImage(null); getVideo(); handleOpen(); }} style={{ height: "40px", padding: "16px", borderRadius: "34px", backgroundColor: "#F5F7F9", border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ fontSize: "14px", fontWeight: "700", color: "#212129" }}>Retake</div>
              </button>

              <button style={{ opacity: image == null ? 0.7 : 1, height: "40px", padding: "16px", borderRadius: "34px", backgroundColor: "#6929E2", border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '8px', }} onClick={() => {
                if (image != null) {
                  onSuccess(image)
                }
              }} >
                <div style={{ fontSize: "14px", fontWeight: "700", color: "#FFFFFF" }}>Proceed</div>

              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>);

}

export default CapturePictureModal;